export default __webpack_public_path__ + "static/media/a001-ransomware-03.56071575.png";